import { render, staticRenderFns } from "./auction-category-view.vue?vue&type=template&id=15daf1b5&"
import script from "./auction-category-view.vue?vue&type=script&lang=js&"
export * from "./auction-category-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports